var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 6H12.75H11.25H6.75H5.25H4.5C3.675 6 3 6.675 3 7.5V15C3 15.825 3.675 16.5 4.5 16.5H13.5C14.325 16.5 15 15.825 15 15V7.5C15 6.675 14.325 6 13.5 6ZM7.5 11.25C7.5 12.075 8.175 12.75 9 12.75C9.825 12.75 10.5 12.075 10.5 11.25C10.5 10.425 9.825 9.75 9 9.75C8.175 9.75 7.5 10.425 7.5 11.25Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.5C1.25 2.43 2.93 0.75 5 0.75C7.07 0.75 8.75 2.43 8.75 4.5V6H7.25V4.5C7.25 3.255 6.245 2.25 5 2.25C3.755 2.25 2.75 3.255 2.75 4.5H1.25Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenIcon);
export default __webpack_public_path__ + "static/media/lockOpenIcon.3db2a9ca.svg";
export { ForwardRef as ReactComponent };